import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=41b74467&scoped=true&"
var script = {}
import style0 from "./delete.vue?vue&type=style&index=0&id=41b74467&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b74467",
  null
  
)

export default component.exports